const rawApiBaseUrl =
  process.env.REACT_APP_API_ENDPOINT_URL || process.env.REACT_APP_API_URL;

export const API_BASE_URL = rawApiBaseUrl
  ? rawApiBaseUrl.replace(/^["']|["']$/g, "").replace(/\/+$/, "")
  : "";

export const apiUrl = (path = "") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${API_BASE_URL}${normalizedPath}`;
};
